module.exports = __webpack_public_path__ + "img/yoga-couple.20b4034.svg";